<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body">

      <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

        <app-rich-text-editor
          *ngIf="contentLoaded"
          placeholder="Noticeboard Content"
          [(ngModel)]="site.induction_content"
          name="induction_content"
          [height]="500">
        </app-rich-text-editor>

        <div class="row mt-2">
          <div class="col">
            <button
              mat-raised-button
              [disabled]="!f.valid || inProgress"
              (click)="onSubmit(f)"
              color="primary"
              class="my-2 ml-0 mr-2"
              type="button">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
